import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useLabelsStore = defineStore(
    'labelsStore',
    () => {
        const labels = ref([]);
        
        const chatlabels = ref([])
        // Get labels
        const getLabels = computed(() => labels.value);

        // Set labels
        const setLabels = (value) => {
            labels.value = value;
        };

        const setChatLabels = (value) => {
            chatlabels.value = value;
        };

        const getLabelsByIds = computed(() => (labelIds) => { 
            if (!Array.isArray(labelIds) || !chatlabels.value) return []
            return chatlabels.value?.filter((label) => labelIds.includes(label._id));
        });

        return {
            labels,
            getLabels,
            setLabels,
            setChatLabels,
            getLabelsByIds,
        };
    },
    {
        persist: true
    });
